export default __webpack_public_path__ + "static/media/goodtimes-small.94ab060d.png";